export default __webpack_public_path__ + "static/media/logo_white.6f3e87a6.png";